import { SubCapabilityKey, useApplicationCapabilitiesAllowed } from "@next-platform/client-common-core/infra/application/capabilities";

import type { FilterPanelCharacterProps } from "../FilterBox/types";
import { DisplayContext } from "../types";
import { FilterSectionV2Id } from "./FilterSectionV2Id";
import useRegisterFilterSectionV2 from "./useRegisterFilterSectionV2";

type UseRegisterCharacterFilterSectionsV2Params = Pick<
  FilterPanelCharacterProps,
  | "context"
  | "hasFilterDefinition"
  | "tagRefinementCount"
  | "languageRefinementCount"
  | "definitionRefinementCount"
  | "chatSizeRefinementCount"
  | "tagsListData"
  | "tagsActionHandler"
  | "definitionListData"
  | "definitionActionHandler"
  | "languageListData"
  | "languageActionHandler"
  | "chatSizeListData"
  | "chatSizeActionHandler"
>;

const useRegisterCharacterFilterSectionsV2 = ({
  context,
  hasFilterDefinition,
  tagRefinementCount,
  languageRefinementCount,
  definitionRefinementCount,
  chatSizeRefinementCount,
  tagsListData,
  tagsActionHandler,
  definitionListData,
  definitionActionHandler,
  languageListData,
  languageActionHandler,
  chatSizeListData,
  chatSizeActionHandler,
}: UseRegisterCharacterFilterSectionsV2Params) => {
  const [isDefinitionAllowed, isLanguageAllowed, isGroupsAllowed] = useApplicationCapabilitiesAllowed([
    SubCapabilityKey.DiscoverFilterDefinitionSize,
    SubCapabilityKey.DiscoverFilterLanguage,
    SubCapabilityKey.DiscoverFilterGroups,
  ]);

  useRegisterFilterSectionV2({
    sectionId: FilterSectionV2Id.TAGS,
    items: tagsListData,
    actionHandler: tagsActionHandler,
    activeRefinementCount: tagRefinementCount,
  });
  useRegisterFilterSectionV2({
    sectionId: FilterSectionV2Id.DEFINITION_SIZE,
    items: definitionListData,
    actionHandler: definitionActionHandler,
    activeRefinementCount: definitionRefinementCount,
    isEnabled: hasFilterDefinition && isDefinitionAllowed,
  });
  useRegisterFilterSectionV2({
    sectionId: FilterSectionV2Id.LANGUAGE,
    items: languageListData,
    actionHandler: languageActionHandler,
    activeRefinementCount: languageRefinementCount,
    isEnabled: isLanguageAllowed,
  });
  useRegisterFilterSectionV2({
    sectionId: FilterSectionV2Id.CHAT_SIZE,
    items: chatSizeListData,
    actionHandler: chatSizeActionHandler,
    activeRefinementCount: chatSizeRefinementCount,
    isEnabled: context !== DisplayContext.MEMBER_SELECT && isGroupsAllowed,
  });
};

export default useRegisterCharacterFilterSectionsV2;
